import React from 'react'

import './footer.css'

const Footer = () => (
    <footer className="app-footer">
        <span className="app-footer__message">
           
            {/* blog.matheuscastiglioni.com.br */}
        </span>
    </footer>
)

export default Footer;